// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { DEFAULT_COMPONENT_ICONS, FluentThemeProvider } from '@azure/communication-react';
import { initializeIcons, registerIcons } from '@fluentui/react';
import { PrimaryButton, Stack, Text } from '@fluentui/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import TopNav from '../../components/TopNav';
import { useAuthStatus } from '../../utils/useAuthStatus';

initializeIcons();
registerIcons({ icons: DEFAULT_COMPONENT_ICONS });
const redirectUri = '/app/v1';

function App(): JSX.Element {
  const { isAuthenticated, isAdmin, authError } = useAuthStatus({
    authProvider: 'sso',
    redirectUri,
    autoStart: true
  });
  const navigate = useNavigate();
  const basePath = location.pathname.startsWith('/app/v2') ? '/app/v2' : '/app/v1';

  useEffect(() => {
    if (isAuthenticated) {
      if (isAdmin) {
        navigate(`${basePath}/admin`);
      } else {
        navigate(`${basePath}/interview`);
      }
    }
  }, [isAuthenticated]);

  return (
    <FluentThemeProvider>
      <Stack
        tokens={{ childrenGap: 32 }}
        styles={{
          root: {
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column'
          }
        }}
      >
        <TopNav isAuthenticated={isAuthenticated} isAdmin={isAdmin} />
        <Stack tokens={{ childrenGap: 32 }} styles={{ root: { flexGrow: 1 } }}>
          {authError && (
            <Stack tokens={{ childrenGap: 12 }}>
              <Text variant="medium">{authError}</Text>
            </Stack>
          )}
        </Stack>
      </Stack>
    </FluentThemeProvider>
  );
}

export default App;
